export enum viewOptionValues {
  APPEASEMENTS = 'appeasements',
  DETAILS = 'details',
  FEED = 'feed',
  RESERVATIONS = 'reservations',
  STAY_COMMITMENTS = 'stay_commitments',
  TICKETS = 'tickets',
}

export const viewOptions = [
  {
    name: 'Details',
    value: viewOptionValues.DETAILS,
  },
  {
    name: 'Reservations',
    value: viewOptionValues.RESERVATIONS,
  },
  {
    name: 'Tickets',
    value: viewOptionValues.TICKETS,
  },
  {
    name: 'Stay Commitments',
    value: viewOptionValues.STAY_COMMITMENTS,
  },
  {
    name: 'Appeasements',
    value: viewOptionValues.APPEASEMENTS,
  },
  {
    name: 'Communications',
    value: viewOptionValues.FEED,
  },
]
